/**
 * Resolves a chain of redirect results, returning a Promise that resolves to `true` if any of the redirect results are truthy, or `false` otherwise.
 *
 * @param {...(Function|Promise|any)} redirectResults - An array of redirect results, which can be functions, Promises, or any other value.
 * @returns {Promise<boolean>} A Promise that resolves to `true` if any of the redirect results are truthy, or `false` otherwise.
 */
export function resolveChain(...redirectResults) {
  return redirectResults.reduce((prev, curr) => {
      return prev.then(result => {
          if (result) return true;
          let next = curr instanceof Function ? curr() : curr;
          if (next && typeof next?.subscribe === 'function') {
              return new Promise(resolve => next.subscribe(resolve));
          }
          return next instanceof Promise ? next : Promise.resolve(next);
      });
  }, Promise.resolve(false));
}
